import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=0e5295c4&scoped=true"
import script from "./Exchange.vue?vue&type=script&setup=true&lang=js"
export * from "./Exchange.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Exchange.vue?vue&type=style&index=0&id=0e5295c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5295c4",
  null
  
)

export default component.exports